const formTools = {
    sbjcData: function () {
        let cookieGa = '_ga',
            cookieValueGa = "",
            ga6SKR50Z3WEValue = '_ga_6SKR50Z3WE',
            cookieValuega6SKR50Z3WE = "",
            userAgent = navigator.userAgent,
            gclidValue = "";

        if (document.cookie.indexOf(cookieGa) > -1) {
            cookieValueGa = document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + cookieGa + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
            cookieValueGa = cookieValueGa.substring(6);
        }

        if (document.cookie.indexOf(ga6SKR50Z3WEValue) > -1) {
            cookieValuega6SKR50Z3WE = document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + ga6SKR50Z3WEValue + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
        }

        let sbjsCookieValue = this.getCookie('sbjs_current_add');
        if (sbjsCookieValue) {
            let decodedString = decodeURIComponent(sbjsCookieValue);
            let regex = /[?&]gclid=([^&#]*)/;
            let match = regex.exec(decodedString);
            if (match) {
                gclidValue = decodeURIComponent(match[1].replace(/\+/g, ' '));
            }
        }

        return {
            utm_source: sbjs.get?.current?.src || "",
            utm_medium: sbjs.get?.current?.mdm || "",
            utm_campaign: sbjs.get?.current?.cmp || "",
            utm_content: sbjs.get?.current?.cnt || "",
            utm_term: sbjs.get?.current?.trm || "",
            client_id: cookieValueGa,
            session_id: cookieValuega6SKR50Z3WE,
            gclid: gclidValue,
            user_agent: userAgent,
        };
    },

    getCookie: function (name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        return parts.length == 2 ? parts.pop().split(";").shift() : null;
    },

    isValidEmail: function (email) {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return pattern.test(email);
    },

    isValidPhone: function (phone) {
        const pattern = /^\+?\d{10,15}$/;
        return pattern.test(phone.replace(/\D/g, ''));
    },

    loaderForm: function (form, status) {
        const subj = form.attr('data-subj')
        let parent = form.closest('div[data-modal]').find('.modal__container');
        if (subj == 'checkout') {
            parent = form.closest('.js_checkout__wrapper')
        }
        if (status == 'start') {
            form.hide();
            if (subj == 'checkout') {
                $('.js_checkout__cart, .js_checkout__forms').hide()
            }
            const svg = `
                <svg version="1.1" id="L6" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                <rect fill="none" stroke="#fff" stroke-width="4" x="25" y="25" width="50" height="50">
                    <animateTransform attributeName="transform" dur="0.5s" from="0 50 50" to="180 50 50" type="rotate" id="strokeBox" attributeType="XML" begin="rectBox.end" />
                </rect>
                <rect x="27" y="27" fill="#fff" width="46" height="50">
                    <animate attributeName="height" dur="1.3s" attributeType="XML" from="50" to="0" id="rectBox" fill="freeze" begin="0s;strokeBox.end" />
                </rect>
                </svg>
                `;
            parent.append(`<div class="loader_form js__loader_form">${svg}</div>`);
        } else {
            form.show();
            if (subj == 'checkout') {
                $('.js_checkout__cart, .js_checkout__forms').show()
            }
            parent.find('.js__loader_form').remove();
            this.toggleButton('unDisabled', form);
        }
    },

    clearForm: function (form) {
        form.find('input[type="text"], input[type="password"], input[type="tel"]').val('');
    },

    showError: function (wrapper, errorType) {
        wrapper.addClass('error_input');
        wrapper.find(`.js__main_error[data-error="${errorType}"]`).slideDown('slow');
    },

    clearErrors: function (wrapper) {
        wrapper.removeClass('error_input');
        wrapper.find('.js__main_error').hide();
    },

    toggleButton: function (toggle, form) {
        const button = form.find('button[type="submit"]');
        if (toggle == 'disabled') {
            button.addClass('disabled').prop('disabled', true);
        } else {
            button.removeClass('disabled').prop('disabled', false);
        }
    },

    sortRequestForm: function (name, objectData, form) {
        const additionalSettings = {
            form: form,
            gtmName: ''
        };
        switch (name) {
            case 'login_account':
                additionalSettings.thankYouModal = 'thank_welcome_back';
                this.sendLogin(objectData, additionalSettings);
                break;
            case 'recover_password':
                additionalSettings.thankYouModal = 'thank_password_forgot';
                this.sendPasswordForgot(objectData, additionalSettings);
                break;
            case 'create_account':
                additionalSettings.thankYouModal = 'thank_welcome';
                this.sendRegister(objectData, additionalSettings);
                break;
            case 'callback':
                additionalSettings.gtmName = 'callback';
                additionalSettings.thankYouModal = 'thank_request_lead';
                this.send(objectData, additionalSettings);
                break;
            case 'feedback':
                additionalSettings.gtmName = 'contact_form';
                additionalSettings.thankYouModal = 'thank_request_lead';
                this.send(objectData, additionalSettings);
                break;
            case 'good_request':
                additionalSettings.gtmName = 'good_request';
                additionalSettings.thankYouModal = 'thank_request_lead';
                this.send(objectData, additionalSettings);
                break;
            case 'price_request':
                additionalSettings.gtmName = 'price_request';
                additionalSettings.thankYouModal = 'thank_request_lead';
                this.send(objectData, additionalSettings);
                break;
            case 'review':
                additionalSettings.gtmName = 'feedback';
                additionalSettings.thankYouModal = 'thank_review';
                this.send(objectData, additionalSettings);
                break;
            case 'market_order':
                additionalSettings.thankYouModal = 'thank_request_order';
                this.buyOneClick(objectData, additionalSettings);
                break;
            case 'checkout':
                this.sendOrder(objectData, additionalSettings)
                break;
            case 'user_data_update':
                this.userDataUpdate(objectData, additionalSettings);
                break;
            default:
                console.warn('No handler for form submission:', name);
                this.loaderForm(form, 'stop');
                break;
        }
    },

    sendOrder: function (objectData, settings) {
        $.post(requests.sendOrder, objectData, (data) => {
            this.loaderForm(settings.form, 'stop');
            switch (data.status) {
                case 'success_monobank':
                    window.location.href = data.link
                    break;
                case 'success':
                    const orderId = data.order_id
                    $('.js_checkout__wrapper').remove()
                    $('.js_checkout__form-is-send span').text(orderId)
                    $('.js_checkout__form-is-send').addClass('active');
                    toolsGtm.gtmCheckout(data.gtm_info, data.order_info);
                    break;
                case 'empty_cart':
                    $('.js_checkout__wrapper').remove()
                    $('.js_checkout__form-cart-empty').addClass('active')
                    break;
                default:
                    break;
            }
        });
    },

    buyOneClick: function (objectData, settings) {
        $.post(requests.buyOneClick, objectData, (data) => {
            this.loaderForm(settings.form, 'stop');
            if (data.status == 'success') {
                this.clearForm(settings.form);
                handleModalAction(settings.thankYouModal);
                toolsGtm.gtmBuyOneClick(data.gtm_info, data.order_info);
            } else {
                console.error('Buy one click error:', data);
            }
        });
    },

    send: function (objectData, settings) {
        $.post(requests.sendForm, objectData, (data) => {
            this.loaderForm(settings.form, 'stop');
            if (data.status == 'success') {
                this.clearForm(settings.form);
                toolsGtm.sendGtm(settings.gtmName);
                handleModalAction(settings.thankYouModal);
            } else {
                console.error('Form submission error:', data);
            }
        });
    },

    sendLogin: function (objectData, settings) {
        $.post(requests.login, objectData, (data) => {
            this.loaderForm(settings.form, 'stop');
            if (data.status == 'error_login' || data.status == 'error_password') {
                const field = data.status == 'error_login' ? 'login' : 'password';
                const wrapper = settings.form.find(`input[name="${field}"]`).closest('.input__wrapper');
                this.showError(wrapper, data.status == 'error_login' ? 'not_valid_login' : 'not_valid_password');
            } else if (data.status == 'success') {
                this.clearForm(settings.form);
                handleModalAction(settings.thankYouModal);
                this.reloadPage();
            }
        });
    },

    sendPasswordForgot: function (objectData, settings) {
        $.post(requests.passwordForgot, objectData, (data) => {
            this.loaderForm(settings.form, 'stop');
            if (data.status == 'error_login') {
                const wrapper = settings.form.find('input[name="login"]').closest('.input__wrapper');
                this.showError(wrapper, 'not_valid_login');
            } else if (data.status == 'success_email') {
                this.clearForm(settings.form);
                handleModalAction(settings.thankYouModal);
            }
        });
    },

    sendRegister: function (objectData, settings) {
        $.post(requests.register, objectData, (data) => {
            this.loaderForm(settings.form, 'stop');
            if (data.status == 'error_login_busy' || data.status == 'error_valid_phone') {
                const field = data.status == 'error_login_busy' ? 'login' : 'phone';
                const wrapper = settings.form.find(`input[name="${field}"]`).closest('.input__wrapper');
                this.showError(wrapper, data.status == 'error_login_busy' ? 'not_valid_login' : 'not_valid_phone');
            } else if (data.status == 'success_account_restored') {
                toolsGtm.gtmRegister();
                this.clearForm(settings.form);
                handleModalAction('account_restored');
            } else if (data.status == 'success_email') {
                toolsGtm.gtmRegister();
                this.clearForm(settings.form);
                handleModalAction(settings.thankYouModal);
            }
        });
    },

    reloadPage: function () {
        setTimeout(() => location.reload(), 2000);
    },

    showPass(button) {
        const passInput = button.prev('.js_form__input')
        if (button.hasClass('active')) {
            button.removeClass('active')
            passInput.attr('type', 'password')
        } else {
            button.addClass('active')
            passInput.attr('type', 'text')
        }
    },

    userDataUpdate(objectData, settings) {
        delete objectData.subj
        delete objectData.lang
        delete objectData.sbjs
        $.post(requests.userDataUpdate, objectData, (data) => {
            this.loaderForm(settings.form, 'stop');
            if (data.status == 'success') {
                handleModalAction('save_user_data');
            }
        });
    },

    assembleDataObject(form) {
        let objData = {}
        let error = 0

        form.find('input:not(:disabled), textarea:not(:disabled), select:not(.js_select__phone-code):not(:disabled)').each((i, el) => {
            const wrapper = $(el).closest('.input__wrapper')
            const name = $(el).attr('name')
            const phones = ['phone', 'phone_1', 'phone_2']

            if (name) {
                if ($(el).is('select')) {
                    if (wrapper.is('.reqiured') && (!$(el).val() || $(el).val() == 'default')) {
                        formTools.showError(wrapper, 'main_error');
                        // console.log(name)
                        error++
                    } else {
                        if ($(el).is('.js_nova-post-unit')) {
                            const postUnitInput = wrapper.siblings('[name=new_post_uuid]')
                            objData[postUnitInput.attr('name')] = postUnitInput.val()
                        } else {
                            objData[name] = $(el).val();
                        }
                    }
                } else if ($(el).is('[type=radio]')) {
                    if (!objData[name]) {
                        objData[name] = '';
                        if (wrapper.is('.required') && !wrapper.find('input:checked').length && !(name in objData)) {
                            formTools.showError(wrapper, 'main_error');
                            // console.log(name)
                            error++
                        } else {
                            wrapper.find('input:checked').length ? objData[name] = wrapper.find('input:checked').attr('value') : ''
                        }
                    }
                } else {
                    let value = $(el).val().trim()
                    if (phones.includes(name)) {
                        value = value.replace(/\D/g, '')
                    }
                    if (wrapper.hasClass('required')) {
                        if (!value) {
                            formTools.showError(wrapper, 'main_error');
                            // console.log(name)
                            error++;
                        } else if (name == 'login' && !formTools.isValidEmail(value)) {
                            formTools.showError(wrapper, 'not_valid_login');
                            // console.log(name)
                            error++;
                        } else if (name == 'email' && !formTools.isValidEmail(value)) {
                            formTools.showError(wrapper, 'not_valid_email');
                            // console.log(name)
                            error++;
                        } else if (phones.includes(name) && !$(el).is('.js_phone_input_int') && !formTools.isValidPhone(value)) {
                            formTools.showError(wrapper, 'not_valid_phone');
                            // console.log(name)
                            error++;
                        } else {
                            if (phones.includes(name) && $(el).is('.js_phone_input_int')) {
                                const code = $(el).siblings('.js_select__phone-code').val()
                                if (!code) {
                                    formTools.showError(wrapper, 'not_valid_code');
                                    // console.log(name)
                                    error++;
                                } else {
                                    objData[name] = parseInt(code) + value;
                                }
                            } else {
                                objData[name] = value;
                            }
                        }
                    } else {
                        if (value && name == 'login' && !formTools.isValidEmail(value)) {
                            formTools.showError(wrapper, 'not_valid_login');
                            // console.log(name)
                            error++;
                        } else if (value && name == 'email' && !formTools.isValidEmail(value)) {
                            formTools.showError(wrapper, 'not_valid_email');
                            // console.log(name)
                            error++;
                        } else if (value && phones.includes(name)) {
                            if (!$(el).is('.js_phone_input_int')) {
                                if (!formTools.isValidPhone(value)) {
                                    formTools.showError(wrapper, 'not_valid_phone');
                                    // console.log(name)
                                    error++;
                                } else {
                                    objData[name] = value;
                                }
                            }
                        } else {
                            objData[name] = value;
                        }
                    }
                }
            }
        })

        return error ? null : objData
    },

    setRating(input) {
        const value = input.attr('value')
        const wrapper = input.closest('.input__wrapper')
        wrapper.find('.star_not_empty').removeClass('active')
        wrapper.find('.star_not_empty').each((i, el) => {
            let label = $(el).closest('label')
            if ((label).attr('data-val') <= value) {
                $(el).addClass('active')
            }
        })
    }
};

window.formValidate = formTools.assembleDataObject

$(document).ready(function () {
    let recaptchaKey = null;

    $.post(requests.getRecaptcha, {}, (data) => {
        if (data.status == 'success') {
            if (data.public_key) {
                recaptchaKey = data.public_key;
                const script = document.createElement('script');
                script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
                document.head.appendChild(script);
            }
        }
    });


    $(document).on('click', '.js_form__input-pass', function () {
        formTools.showPass($(this))
    })

    $(document).on('input', '.form__input, .form__textarea', function () {
        const wrapper = $(this).closest('.input__wrapper');
        formTools.clearErrors(wrapper);
    });

    $(document).on('change', '.form__radio', function () {
        const wrapper = $(this).closest('.input__wrapper');
        formTools.clearErrors(wrapper);
    });

    $(document).on('submit', 'form[data-subj]', function (e) {
        e.preventDefault();
        const form = $(this);
        const requestName = form.data('subj');
        const objectData = { lang: 'ru', subj: requestName, sbjs: formTools.sbjcData() };
        let formData = formTools.assembleDataObject(form)

        if (formData) {
            if (recaptchaKey) {
                grecaptcha.ready(() => {
                    grecaptcha.execute(recaptchaKey, { action: 'submit' }).then((token) => {
                        objectData['g-recaptcha-response'] = token;
                        Object.assign(objectData, formData)
                        formTools.loaderForm(form, 'start');
                        formTools.toggleButton('disabled', form);
                        formTools.sortRequestForm(requestName, objectData, form);
                    });
                });
            } else {
                Object.assign(objectData, formData)
                formTools.loaderForm(form, 'start');
                formTools.toggleButton('disabled', form);
                formTools.sortRequestForm(requestName, objectData, form);
            }
        } else {
            formTools.toggleButton('unDisabled', form);
        }
    });

    $(document).on('click', 'button[data-load-modal]', function () {
        const modalName = $(this).data('load-modal');
        $(`div[data-modal]`).hide();
        $(`div[data-modal="${modalName}"]`).show();
    });

    $(document).on('change', '.js_form-radio', function () {
        formTools.setRating($(this))
    })

    $(document).on('change', 'select:not(.js_select__phone-code)', function () {
        const wrapper = $(this).closest('.input__wrapper');
        formTools.clearErrors(wrapper);
    })
});

window.toolsLoaderForm = formTools.loaderForm;
window.sbjcData = formTools.sbjcData;